import Controller from '../abstracts/Controller';
import 'scss-templates/t-dem-preferences.scss';

export default class PrivacyPreferencesController extends Controller {
  static get COMPONENTS() {
    return [
      'Select2InitComponent'
    ];
  }
}
